import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PutOcrAccountsRequestModel, PutOcrAccountsResponseModel } from "@/features/accounts/ocr/services/put-accounts-model";

export class PutOcrAccountsApi {
  /**
   * OCR口座情報更新API
   */
  public putOcrAccounts = async (
    param: PutOcrAccountsRequestModel
  ): Promise<PutOcrAccountsResponseModel> => {
    const path = `/api/ocraccounts`;
    const res = await ApiClient.instance.put<PutOcrAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
